import { createAction } from '@ngrx/store';

export const isMobileDevice         = createAction('[EVENT DEVICES MOBILE] is Mobile');
export const isDesktopDevice        = createAction('[EVENT DEVICES DESKTOP] Is Desktop');
export const setWebView             = createAction('[EVENT DEVICES SET WEBVIEW] Is WebView');
export const unSetWebView           = createAction('[EVENT DEVICES UNSET WEBVIEW] Is WebView');